var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div data-bind="\n	reactComponent: _params,\n	model: _params.model,\n	attr: { id: _params.name }"> </div>';
}
return __p;
};
